var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "CompassMenu",
    {
      attrs: {
        placement: "bottom-end",
        customClass: "automation-create-automation__menu"
      },
      scopedSlots: _vm._u([
        {
          key: "dropdown",
          fn: function() {
            return [
              _c("CompassMenuItemExtended", {
                attrs: {
                  icon: "obj-slsy-basic-automation",
                  title: _vm.translations.createAutomation.template,
                  caption: _vm.translations.createAutomation.templateCaption
                },
                on: { click: _vm.handleGoToTemplates }
              }),
              _vm._v(" "),
              _c("CompassMenuItemExtended", {
                attrs: {
                  icon: "obj-slsy-advanced-services",
                  title: _vm.translations.createAutomation.services,
                  caption: _vm.translations.createAutomation.servicesCaption
                },
                on: { click: _vm.handleGoToServices }
              }),
              _vm._v(" "),
              _vm.hasAutomationBuilderFeature
                ? _c("CompassMenuItemExtended", {
                    attrs: {
                      icon: "obj-slsy-advanced-automation",
                      title: _vm.translations.createAutomation.automation,
                      caption:
                        _vm.translations.createAutomation.automationCaption
                    },
                    on: { click: _vm.handleCreateAutomation }
                  })
                : _vm._e()
            ]
          },
          proxy: true
        }
      ])
    },
    [
      _c("CompassButton", {
        attrs: {
          label: _vm.translations.createAutomation.labelButton,
          loading: _vm.isLoading,
          dropdown: ""
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }